import { gql } from '@apollo/client';

const RMA_TICKETS_QUERY = gql`
  query RmaTickets($filter: RmaTicketsFilterInput, $limit: Int) {
    RmaTickets(filter: $filter, limit: $limit) {
      id
      rmaId
      status
      facility {
        id
        name
      }
      requestedAt
      recipientInformation {
        devices {
          deviceId
        }
        latestLabel {
          shipmentDate
        }
      }
      senderInformation {
        devices {
          deviceId
        }
      }
      clinicShipmentReminder {
        isReminder
      }
    }
  }
`;
export default RMA_TICKETS_QUERY;
